module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/shadows-tile.8f0110f3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/shadows-tile.png
// module id = 2870
// module chunks = 11